import { render } from "./Mint.vue?vue&type=template&id=70c7882a&scoped=true"
import script from "./Mint.vue?vue&type=script&lang=js"
export * from "./Mint.vue?vue&type=script&lang=js"

import "./Mint.vue?vue&type=style&index=0&id=70c7882a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c7882a"]])

export default __exports__